export default __webpack_public_path__ + "static/media/login_bg_fasting.287c1f18.jpg";